<div class="app" *ngIf="showIframe">
  <div class="frame" >

    <iframe [src]="url" frameborder="0"></iframe>
  </div>
  <a href="https://merytu.com/" target="_blank"> <img class="logo" width="100" src="../assets/imgs/logo_merytu_alto.svg" alt="">
  </a>

</div>
